import { render, staticRenderFns } from "./addReserveServicePerson.vue?vue&type=template&id=62e1f271"
import script from "./addReserveServicePerson.vue?vue&type=script&lang=js"
export * from "./addReserveServicePerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports